import { render, staticRenderFns } from "./PriceBox.vue?vue&type=template&id=aa2a7968&scoped=true&"
import script from "./PriceBox.vue?vue&type=script&lang=js&"
export * from "./PriceBox.vue?vue&type=script&lang=js&"
import style0 from "./PriceBox.vue?vue&type=style&index=0&id=aa2a7968&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2a7968",
  null
  
)

export default component.exports